<template>
  <div class="home">
    <navigation-bar />

    <hero
      @animationEnd="shouldShowContent = true"
    />

    <template v-if="shouldShowContent">
      <introduction
        v-vue-aos.once="{ animationClass:'fadeInUp slow animated' }"
      />
      <categories
        v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
      />
      <join-today />
      <features />
      <talk-to-us />
      <meet-the-team />
      <footer-element class="mt-8" />
    </template>
  </div>
</template>

<script>
// Import children blocks
const Hero = () => import("@/blocks/home/Hero.vue")
const Features = () => import("@/blocks/home/Features.vue")
const TalkToUs = () => import("@/blocks/home/TalkToUs.vue")
const JoinToday = () => import("@/blocks/home/JoinToday.vue")
const Categories = () => import("@/blocks/home/Categories.vue")
const MeetTheTeam = () => import("@/blocks/home/MeetTheTeam.vue")
const Introduction = () => import("@/blocks/home/Introduction.vue")
const NavigationBar = () => import("@/blocks/common/NavigationBar.vue")
const FooterElement = () => import("@/blocks/common/Footer.vue")

// Export the SFC
export default {
  // Name of the component
  name: "Home",

  // Register children components
  components: {
    Hero,
    Features,
    TalkToUs,
    JoinToday,
    Categories,
    MeetTheTeam,
    Introduction,
    NavigationBar,
    FooterElement
  },

  // Define local data variables
  data: () => ({
    shouldShowContent: false
  })
}
</script>
